import axios from 'axios'
import router from '@/router/index'
import { Message } from 'element-ui'
import Cookies from 'js-cookie'
import store from '../store'

//创建一个axios实例
const service = axios.create({
    // baseURL: axios.defaults.baseURL, //根据开发环境和线上环境，切换地址
    timeout:150000,
})
service.defaults.headers.post['Content-Type'] = 'multipart/form-data';


//请求拦截器
service.interceptors.request.use(config => {
    config.baseURL = process.env.BASE_API + '/' +  store.state.agentInfo.distSpId + '/app'
    const token = Cookies.get('dls_token')
    if(token && config.url !== '/ajax/register' && config.url !== '/main/login') {
        config.headers['Authorization'] = `${JSON.parse(token).tokenType}-${JSON.parse(token).accessToken}`
    }
    return config
}, error => {
    Promise.reject(error)
})

//响应拦截器
service.interceptors.response.use(response => {
    
    if (response.data.code && response.data.code!="100001"){
        Message.error(response.data.message)
    }
    //session过期
    if (response.data.code == "100100" || response.data.code == "100101") {
        router.push({ path: '/login', query:{toback: 1} })
    }
	return response
}, error => {
    if (error.response.status == 404){
        //进入404页面
        router.push({ path: '/404' })
    }
    else if (error.response.status == 500 || error.response.status == 504) {
        //进入500页面
        Message.error('接口异常，或登录超时！')
        router.push({ path: '/500' })
    }
    else{
        Message.error('接口异常，或登录超时！')
    }
    
    return Promise.reject(error)
})

export default service


// WEBPACK FOOTER //
// ./src/utils/axios.js